/**
 * Reusable Page Message Component
 * Displays loading, error, or informational messages
 */

import React from 'react';

const PageMessage = ({ message, type = 'info' }) => {
  const getMessageStyle = () => {
    const baseStyle = {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      margin: 0,
      padding: 0,
      width: '100%',
    };

    const containerStyle = {
      padding: 20,
      width: '100%',
    };

    const contentStyle = {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      alignItems: 'center',
      height: '100%',
      fontSize: 14,
      color: type === 'error' ? '#d32f2f' : type === 'success' ? '#2e7d32' : '#666',
    };

    return { baseStyle, containerStyle, contentStyle };
  };

  const { baseStyle, containerStyle, contentStyle } = getMessageStyle();

  return (
    <div style={baseStyle}>
      <div className="container" style={containerStyle}>
        <div style={{ width: '100%', height: '100%' }}>
          <div style={contentStyle}>
            {message}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageMessage;
